 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"vendors~dashboard1~dashboard2~dashboard25~dashboard27~dashboard8","5":"dashboard1~dashboard2","6":"adminRoles","7":"adminUser","8":"bannerSettings","10":"commonSettings","11":"contentPage","12":"contentPagePreview","13":"dashboard","14":"dashboard1","15":"dashboard10","16":"dashboard11","17":"dashboard12","18":"dashboard13","19":"dashboard14","20":"dashboard15","21":"dashboard16","22":"dashboard17","23":"dashboard18","24":"dashboard19","25":"dashboard2","26":"dashboard20","27":"dashboard21","28":"dashboard22","29":"dashboard23","30":"dashboard24","31":"dashboard25","32":"dashboard26","33":"dashboard27","34":"dashboard28","35":"dashboard29","36":"dashboard3","37":"dashboard30","38":"dashboard31","39":"dashboard33","40":"dashboard34","41":"dashboard35","42":"dashboard36","43":"dashboard37","44":"dashboard39","45":"dashboard4","46":"dashboard5","47":"dashboard6","48":"dashboard7","49":"dashboard8","50":"dashboard9","51":"editDocument","52":"editRestaurant","53":"editStore","54":"home","55":"infoSettings","56":"legal","57":"login","58":"manageServiceFee","59":"not-found","60":"polyfills","61":"pricing","62":"restaurant","63":"restaurant-addfooditem","64":"restaurant-drivers","65":"restaurant-menu","66":"restaurant-menu-add","67":"restaurant-modifiergroups","68":"restaurant-operation-hours","69":"restaurant-password","70":"restaurant-preparation-time","71":"restaurant-signup","72":"restaurantsList","73":"sliderSettings","74":"static","75":"storeList","76":"vehicleType","78":"vendors~dashboard","79":"vendors~polyfills"}[chunkId]||chunkId) + "." + {"0":"6fd402a8","1":"cfe6df05","2":"64c65198","3":"3c972015","4":"9c62d934","5":"d5503bb5","6":"02c2b1da","7":"80d0ce0c","8":"ac9cfe91","10":"b5d2a2e9","11":"4e9b3dd0","12":"1ecf984e","13":"f682056a","14":"78e523fc","15":"8fa0b646","16":"76eaee10","17":"656dfaf9","18":"1e49227c","19":"0dc734a2","20":"10cc5171","21":"54862379","22":"6dd7b6a4","23":"e84baa73","24":"6e3bda39","25":"514e69de","26":"2bcb730f","27":"00903cc5","28":"6ac3cbf1","29":"e62a9b5e","30":"c782b132","31":"26f85634","32":"2a82c730","33":"e53665f0","34":"4eb24c08","35":"589e1000","36":"bf2ad3ec","37":"9a306901","38":"f939ac3d","39":"15a58ae1","40":"609edc2f","41":"75d68192","42":"256e82ef","43":"60d80aeb","44":"c32138d2","45":"8f6e8c78","46":"553888c5","47":"65a612e2","48":"6c3177f5","49":"879b3dd7","50":"ab1fc978","51":"123c0206","52":"7445ff07","53":"4c35bc70","54":"6cf32322","55":"bd5ed7a8","56":"32ddea82","57":"3f32aef8","58":"0de62ecb","59":"7c983082","60":"c25deea9","61":"ddccf8cc","62":"d39a34cd","63":"1c7bc45a","64":"942eba6e","65":"4c990bf1","66":"d3af3a38","67":"47991ca4","68":"041d80ce","69":"3e867a53","70":"6967b0ca","71":"f262f3c9","72":"f1f1d0ae","73":"4582b43f","74":"ded7be3e","75":"8404594a","76":"3ade8c7c","78":"a1a853e6","79":"1067721a","80":"8702fe65"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([270,77]);
 	// run deferred modules when ready
 	return checkDeferredModules();
